import { TemplateList } from "../@types";
import { client, getErrorMessage } from "./client";

const baseUrl = "/servers";

export const getServers = async () => {
  try {
    const response = await client.get(`${baseUrl}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAIInfo = async (server?: string) => {
  try {
    const queryParams = new URLSearchParams();
    if (server !== undefined) {
      queryParams.append("server", server.toString());
    }
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
    const response = await client.get(`${baseUrl}/ai-info${queryString}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getServerList = async () => {
  try {
    const response = await client.get(`${baseUrl}/server-list`);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restartServer = async () => {
  try {
    const response = await client.post(`${baseUrl}/restart`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};
